import {Subscription} from 'rxjs';

import IPlayer    from '../../Player/Interfaces/IPlayer';
import IAnalytics from '../Shared/Interfaces/IAnalytics';

import IPlayerStateManagerResolver            from './Interfaces/IPlayerStateManagerResolver';
import createPlaybackQualityChangeStream      from './Streams/createPlaybackQualityChangeStream';
import createPlaybackStatusWithPlaybackStream from './Streams/createPlaybackStatusWithPlaybackStream';
import subscribeToErrors                      from './Subscribers/subscribeToErrors';
import subscribeToPlaybackQualityChange       from './Subscribers/subscribeToPlaybackQualityChange';
import subscribeToPlaybackStatus              from './Subscribers/subscribeToPlaybackStatus';
import Conviva                                from './Vendor/Conviva';

const connectAnalyticsSubscriptions = (
    analytics: IAnalytics,
    player: IPlayer,
    getPlayerStateManager: IPlayerStateManagerResolver,
    client: Conviva.Client
): Subscription[] => {
    const {playback} = player.state.stores;

    return [
        subscribeToErrors(player.consumerOutput.errors$, client, analytics),
        subscribeToPlaybackStatus(
            createPlaybackStatusWithPlaybackStream(playback.update$),
            client,
            getPlayerStateManager,
            analytics
        ),
        subscribeToPlaybackQualityChange(createPlaybackQualityChangeStream(playback.update$), getPlayerStateManager)
    ];
};

export default connectAnalyticsSubscriptions;